import InventoryListTargetingApi from '@/api/InventoryListTargeting'

export class InventoryListTargetingModel {
  constructor(item) {
    const {
      id,
      ownerProfileId,
      resourceId,
      resourceType,
      resourceName,
      inventoryCount,
      name,
      description,
      blackOrWhite,
      isDefaultAttach,
    } = item
    this.id = Number(id) || undefined
    this.ownerProfileId = ownerProfileId || undefined
    this.resourceId = resourceId || undefined
    this.resourceType = resourceType || undefined
    this.resourceName = resourceName || undefined
    this.inventoryCount =
      inventoryCount != null ? Number(inventoryCount) : undefined
    this.name = name || undefined
    this.description = description || undefined
    this.blackOrWhite = blackOrWhite || undefined
    this.isDefaultAttach = isDefaultAttach || undefined
  }
  get isDefaultAttachText() {
    return this.isDefaultAttach ? '自動' : '手動'
  }
  getResourceTypeName() {
    switch (this.resourceType) {
      case 'advertiser':
        return '広告主'
      case 'oem':
        return '共通'
      case 'agency':
        return '代理店'
      case 'insertion_order':
        return '案件'
    }
    return ''
  }
  static async findByOwnerProfileId(params) {
    const ret = await InventoryListTargetingApi.fetchInventoryTargetingList(
      params,
    )
    return ret
  }
  static async fetchInventoryRequiredLists(
    insertionorderId,
    ownerProfileMenuId,
  ) {
    const ret = await InventoryListTargetingApi.fetchInventoryRequiredLists(
      insertionorderId,
      ownerProfileMenuId,
    )
    return ret
  }
  static async fetchInventoryOptionalLists(
    insertionorderId,
    ownerProfileMenuId,
  ) {
    const ret = await InventoryListTargetingApi.fetchInventoryOptionalLists(
      insertionorderId,
      ownerProfileMenuId,
    )
    return ret
  }
}

export class GetInventoryListForm {
  constructor(item = {}) {
    const { pageSize, pageNo, ownerProfileId } = item
    this.page_size = pageSize || undefined
    this.page_no = pageNo || undefined
    this.owner_profile_id = Number(ownerProfileId) || undefined
  }
}
